<template>
    <div>
        <Spinner v-if="isFetching" :title="'Loading Slots'|trans"></Spinner>

        <!-- ************ URGENCY LEVELS  ************ -->
        <div class="btn-group-urgency" role="group" v-if="!isFetching">
            <button v-for="levelUrgency in levelsOfUrgency"
                    @click="selectLevelOfUrgency(levelUrgency.value)"
                    :class="{'selected': levelUrgencySelected === levelUrgency.value}"
                    type="button" class="btn btn-default adapt-with-33"
            >
                {{levelUrgency.label}}
            </button>
        </div>

        <!-- ************ MANDATORY MESSAGES  ************ -->
        <div v-if="!isReadyForSuggestions">
            <ul class="list-group">
                <li class="list-group-item list-group-item-danger" v-if="dataQuery.interventionAddressZoneId == null">{{ 'Zone is required'|trans}}</li>
                <li class="list-group-item list-group-item-danger" v-if="dataQuery.leafJobTypeId == null"> {{ 'Job Type is required'|trans}} </li>
                <li class="list-group-item list-group-item-danger" v-if="dataQuery.durationRequired == null">{{ 'Duration is required'|trans}}</li>
                <li class="list-group-item list-group-item-danger" v-if="levelUrgencySelected === null">{{ 'Level of urgency is required'|trans}}</li>
            </ul>
        </div>

        <!-- ************ SELECTION LEVELS  ************ -->
        <div v-if="dateSelected!==null" class="alert-success alert">
                <strong class="text-capitalize ">{{dateSelected|formatDate}}</strong>
                <button class="btn btn-danger" @click="ignoreSelection()">
                    {{'Remove Selection '|trans}} <i class="fa fa-times-circle"></i>
                </button>
        </div>

        <!-- ************ SUGGESTIONS   ************ -->
        <div class="for-scroll-limit-height" v-if="!isFetching" ref="suggestionsTable">
            <table class="table table-bordered table-suggestions"
                   v-if="shownSlots !== null"
            >
                <tbody>
                    <tr v-for="(slotWorker, slotIndex) in shownSlots"
                        v-bind:style="{opacity: isDiscarded(slotWorker) ? 0.5 : 1}"
                        v-bind:class="{'selected-slot': (slotSelected !== null && slotSelected.id=== slotWorker.id)}"
                    >
                        <!-- ************  DISCARTED SLOTS ************ -->
                        <template v-if="isDiscarded(slotWorker)">
                            <td>
                                <span class="discard-worker-or-day">
                                    <table class="table">
                                        <tr>
                                            <td width="50%"><span>{{ slotWorker.day | formatDay }}</span></td>
                                            <td width="50%"><span>{{ slotWorker|formatSlotTimeInterval }}</span></td>
                                        </tr>
                                    </table>
                                </span>
                            </td>
                            <td>
                                <div
                                        v-if="slotWorker.fastest"
                                        v-tippy="{arrow: true, animation: 'fade', duration: [100, 100]}"
                                        title="This is our fastest option !"
                                        style="color: green;">
                                    <i class="fa fa-truck" aria-hidden="true"></i>
                                    <i class="fa fa-bars" aria-hidden="true"></i>
                                    {{ slotWorker.virtualDistance }} KM
                                </div>
                                <div v-else>
                                    {{ slotWorker.virtualDistance }} KM
                                </div>

                            </td>
                            <td>
                                <button class="select-day btn btn-primary btn-sm full-width" @click="selectSuggestionSlotDate(slotWorker)">
                                    <i  aria-hidden="true" class="fa fa-thumbs-up"></i>
                                </button>
                            </td>
                        </template>

                        <!-- ************ NON DISCARTED SLOTS ************-->
                        <template v-else>
                            <td>
                                <span class="discard-worker-or-day">
                                    <table class="table ">
                                        <tr >
                                            <td  width="50%">
                                                <table class="full-width">
                                                    <tr>
                                                        <td  class="height-fix"><span>{{ slotWorker.day | formatDay }}</span></td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <button v-on:click="discardDay(slotWorker)" class="btn btn-default btn-sm to90pc spacer-btn-2px">
                                                                <i  class="fa fa-times" aria-hidden="true"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </td>
                                            <td width="50%">
                                                <table class="full-width">
                                                    <tr>
                                                        <td class="height-fix"><span class="no-wrap-string">{{ slotWorker|formatSlotTimeInterval }}</span></td>
                                                    </tr>
                                                    <tr>
                                                        <td><button v-on:click="discardTimeslot(slotWorker)" class="btn btn-default btn-sm to90pc spacer-btn-2px">
                                                    <i  class="fa fa-times" aria-hidden="true"></i>
                                                </button></td>
                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>
                                    </table>
                                </span>
                            </td>
                            <td>
                                <div v-if="slotWorker.fastest"
                                     v-tippy="{arrow: true, animation: 'fade', duration: [100, 100]}" style="color: green;">
                                    <i class="fa fa-truck" aria-hidden="true"></i>
                                    <i class="fa fa-bars" aria-hidden="true"></i>
                                    {{ slotWorker.virtualDistance }} KM
                                </div>
                                <div v-else>
                                    {{ slotWorker.virtualDistance }} KM
                                </div>
                            </td>
                            <td>
                                <button class="select-day btn btn-primary btn-sm full-width" @click="selectSuggestionSlotDate(slotWorker)">
                                    <i  aria-hidden="true" class="fa fa-thumbs-up"></i>
                                </button>
                            </td>
                        </template>
                    </tr>
                </tbody>
            </table>

            <br>
            <div
                    v-if="allSlotsAreShown"
                    class="alert alert-danger alert-shown-all text-center">
                {{ 'No more suggestions to show' | trans }}<br>
                (
                <RouterLink to="availabilities">
                    <i class="icon fa fa-calendar"></i>&nbsp;
                    <span class="title">{{ 'make space in your availabilities' | trans }}</span>
                </RouterLink>
                )
            </div>

        </div>

    </div>
</template>

<script>

    import SlotWorker from "./SlotWorker";
	import Spinner from "../Spinner";
	import moment from 'moment';

	export default {
    	components:{Spinner, SlotWorker},
        props: {
			/**
			 *  query paremeters:
			 *      int     interventionAddressZoneId
			 *      int     leafJobTypeId
			 *      string? interventionType
			 *      int?    restrictToWorkerId
			 *      int     durationRequired
			 *      int     urgencyLevel
			 *      string  initiatorForm
			 *      int?    campaignId
			 *      int?    customerIdWorkerService
			 *      int?    excludedJobId
			 *      bool?   pureContact
			 **/
			dataQuery:Object
        },
        data() {
            return {
				isFetching:false,
				slots:null,
				errorMessage:null,
                /* Selection */
				discardedDays: {},
				discardedTimeslots: {},
                levelsOfUrgency:[
                    {label:'Can Wait', value:0},
					{label:'Asap', value:1},
					{label:'Today', value:2}
                ],
                levelUrgencySelected : null,
                dateSelected:null,
                slotSelected:null,
            }
        },
        created(){
			this.tryTofetchSlots();
        },
        methods: {
			async tryTofetchSlots() {
				this.reset();
				this.slots = null;
				try {
					this.isFetching = true;
					if(
						!this.checkIfHasNullValues(this.dataQuery) && this.levelUrgencySelected !== null
                    ){
						this.slots = await this.$api.slot.suggestForWorker(
                            {
                                interventionAddressZoneId :  this.dataQuery.interventionAddressZoneId,
							    leafJobTypeId :  this.dataQuery.leafJobTypeId,
							    interventionType :  this.dataQuery.interventionType,
							    restrictToWorkerId : this.dataQuery.restrictToWorkerId,
							    durationRequired : this.dataQuery.durationRequired,
							    urgencyLevel : this.levelUrgencySelected,
							    initiatorForm : '',
							    campaignId : 1,
							    customerIdWorkerService :  null,
							    excludedJobId :  null,
							    pureContact :  true
                            }
                        );
						this.isFetching = false;
						this.errorMessage = null;
                    }
				}
				catch (error) {
					if (this.$api.is401(error)) {
						// in case of 401, just abort javascript execution
						return;
					}
					if (this.$api.isCancel(error)) {
						// request canceled programmatically, let the new request do the job
						return;
					}
					if (this.$api.isNoConnectivity(error)) {
						this.errorMessage = this.$options.filters.trans('No connection ?');
					} else {
						this.$bugsnagClient.notify(error);
						this.errorMessage = this.$options.filters.trans('Unknown error');
					}
				}
				this.isFetching = false;
			},
            selectLevelOfUrgency(levelUrgencySelected){
				this.levelUrgencySelected = levelUrgencySelected;
				this.tryTofetchSlots();
            },
			checkIfHasNullValues() {
				return Object.values(this.dataQuery).some(value => value === null);
			},
			isToday(day) {
				// IMPROVEMENT: memoize function ?
				return moment(day).isSame(Date.now(), 'day');
			},
            // --------------- DISCART ------------ //
			isDiscarded(slot) {
				return (
					this.isDayDiscarded(slot)
					|| this.isTimeslotDiscarded(slot)
				);
			},
			isDayDiscarded(slot) {
				return (
					this.discardedDays[slot.day] !== undefined
					|| (
						this.levelUrgencySelected === 2 // 2 = today
						&& !this.isToday(slot.day)
					)
				);
			},
			isTimeslotDiscarded(slot) {
				let isTimeslotDiscarded = false;
				if (this.discardedTimeslots[slot.day] !== undefined) {
					for (const timeslotIndex in this.discardedTimeslots[slot.day]) {
						if (timeslotIndex >= slot.timeslotIndex - 5 && timeslotIndex <= slot.timeslotIndex + 5) {
							isTimeslotDiscarded = true;
							break;
						}
					}
				}
				return isTimeslotDiscarded;
			},
			discardDay(slot) {
				this.$set(this.discardedDays, slot.day, slot);
			},
			discardTimeslot(slot) {
				if (this.discardedTimeslots[slot.day] === undefined) {
					this.$set(this.discardedTimeslots, slot.day, {});
				}
				this.$set(this.discardedTimeslots[slot.day], slot.timeslotIndex, slot);
			},
            selectSuggestionSlotDate(slot){
				this.slotSelected = slot;
                this.dateSelected = moment.unix(slot.timestamp).toDate();
				this.$emit('slotSelected', slot.timestamp);
            },
			ignoreSelection(){
				this.slotSelected = null;
				this.dateSelected = null;
				this.$emit('slotSelected', this.dateSelected); // Emit Null Selection
			},
			reset() {
				this.slots = null;
				this.discardedDays = {};
				this.discardedTimeslots = {};
				this.errorMessage = null;
			},
        },
        watch: {
            dataQuery: {
                handler: function (after,before) {
					this.tryTofetchSlots();
                },
                deep: true,
			},
			async shownSlots() {
				// automatically scroll suggestion table to the bottom when the suggestions list change
				await this.$nextTick();
				if (this.$refs.suggestionsTable !== undefined) {
					this.$refs.suggestionsTable.scrollTop = this.$refs.suggestionsTable.scrollHeight;
				}
			},
        },
		filters: {
			formatDate(date) {
				const momentDay = moment(date);
				const format = 'dddd D MMMM HH:mm';
				if (momentDay.isSame(Date.now(), 'day')) {
					return 'Today ' + momentDay.format(format);
				}
				if (momentDay.isSame(moment().add(1, 'day'), 'day')) {
					return 'Tomorrow' + momentDay.format(format);
				}
				return momentDay.format(format);
			},
			formatDay(day) {
				const momentDay = moment(day);
				if (momentDay.isSame(Date.now(), 'day')) {
					return 'Today';
				}
				if (momentDay.isSame(moment().add(1, 'day'), 'day')) {
					return 'Tomorrow';
				}
				return momentDay.format('dddd D MMMM');
			},
			formatSlotTimeInterval(slot) {
				const parsedTime = moment(slot.time, 'HH:mm:ss');
				return parsedTime.format('H:mm') + ' -> ' + parsedTime.add(2, 'hours').format('H:mm');
			}
		},
        computed:{
			shownSlots() {
				if (this.slots === null) {
					return null;
				}
				const shownSlots = [];
				for (let i = 0; i < this.slots.length; i++) {
					const slot = this.slots[i];
					if (this.isDiscarded(slot)) {
						shownSlots.push(slot);
					}
					else {
						shownSlots.push(slot);
						break;
					}
				}
				return shownSlots;
			},
			allSlotsAreShown() {
				return this.slots !== null && this.shownSlots.length === this.slots.length;
			},
            isReadyForSuggestions(){
				return !this.checkIfHasNullValues && this.levelUrgencySelected !== null
            }
        }
    }

</script>

<style scoped>
    .for-scroll-limit-height{
        max-height: 350px;
        overflow: hidden;
        overflow-y: scroll;
        /*border: 1px solid #e8e8e8;*/
    }

    .table-suggestions,
    .table-suggestions table{
        margin: 0px;
    }
    .table-suggestions td{
        vertical-align: middle;
    }

    .btn-group-urgency .adapt-with-33{
        width: 33.33%;
    }
    .btn-group-urgency{
        padding:4px;
    }
    .select-day{
        color: #93b623;
    }
    .alert-shown-all{
        border: 4px solid #f5ac9d;
        margin: 8px 8px 20px 8px;
    }

    .selected-slot,
    .selected-slot table{
        background-color: #9fdb66;
        color: white;
    }
    .to90pc{
        width: 90%;
    }
    .no-wrap-string{
        white-space: nowrap;
    }
    .height-fix{
        height: 30px;
    }
</style>
